import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { datadogRum } from '@datadog/browser-rum';
import api from '@services/api';
import type { PortfolioType } from '@customTypes/portfolio';

const useGetAllPortfolio = () => {
  const [portfolios, setPortfolios] = useState<PortfolioType[]>([]);
  const [loading, setLoading] = useState(true);

  const getPortfolios = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get('/portfolio/all');
      setPortfolios(response.data);
    } catch (error) {
      toast.error('Erro ao carregar portfólios. Tente novamente mais tarde.');
      datadogRum.addError(new Error('Fail to get full portfolio list'), {
        error,
      });
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    getPortfolios,
    portfolios,
    loading,
  };
};

export default useGetAllPortfolio;
